export default __webpack_public_path__ + "static/4-77f23d2745096589f61fe2fd90aacbd7.jpeg";